import RadarLegalTextPopupTemplate from '~/views/RadarView/components/RadarLegalTextPopupTemplate';

export default function RadarTermsPopup() {
  return <RadarLegalTextPopupTemplate property="terms" />;
}
